import { createStyles } from '@svg/antd/es/theme/utils';

// 列表相关样式
export const listStyles = createStyles(({ token }) => ({
    categoryListBox: {
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        columnGap: '8px',
        rowGap: '6px',
        marginBottom: '16px'
    },
    categoryItemDefault: {
        minWidth: 'calc((100% - 8px) / 2)',
        maxWidth: '100%',
        display: 'flex',
        fontSize: '13px',
        lineHeight: '20px',
        color: '#555B61',
        cursor: 'pointer',
    },
    categoryItemHover: {
        '&:hover': {
            color: token.colorTextTertiary
        }
    },
    categoryItemActive: {
        color: `${token.colorPrimary} !important`,
    },
})); 